var React = require('react');

function Forms (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30.19,54 C44.79,54 58,36.96 58,22.57 C58,8.17 46.45,-1.99 28.82,0.33 C11.20,2.65 0,9.50 0,23.89 C0,38.29 15.59,54 30.19,54 Z","id":"Oval","fill":"#E8E1FA","key":0}),React.createElement("g",{"id":"toggle-left","transform":"translate(18.000000, 20.000000)","stroke":"#5B3BB0","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1},[React.createElement("rect",{"id":"Rectangle","x":"0","y":"0","width":"22","height":"14","rx":"7","key":0}),React.createElement("circle",{"id":"Oval","cx":"7","cy":"7","r":"3","key":1})])]);
}

Forms.defaultProps = {"width":"58px","height":"54px","viewBox":"0 0 58 54","version":"1.1"};

module.exports = Forms;

Forms.default = Forms;
